import type { StoreObject } from "@apollo/client";
import { cache } from "@/helpers/apollo";
import useAnalytics from "@/hooks/use-analytics";
import useAuth from "@/hooks/use-auth";
import type { UserType } from "../types";
import useBlockUser from "./use-block-user";
import useUnblockUser from "./use-unblock-user";

export default function useToggleUserBlock(user: UserType) {
  const [blockUser] = useBlockUser();
  const [unblockUser] = useUnblockUser();
  const { mutationContext } = useAuth();
  const { track } = useAnalytics();

  return () => {
    cache.modify({
      fields: {
        isBlocked: (value) => {
          const newValue = !value;
          (newValue ? blockUser : unblockUser)(
            mutationContext({ userId: user.id })
          );
          return newValue;
        },
      },
      id: cache.identify(user as unknown as StoreObject),
    });

    track(user.isBlocked ? "User Unblocked" : "User Blocked", {
      user_id: user.id,
    });
  };
}
